// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setYear as fn } from "../setYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setYear = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setYear;
